import { render, staticRenderFns } from "./EmissionsTemplate.vue?vue&type=template&id=87895912&scoped=true&"
import script from "./EmissionsTemplate.vue?vue&type=script&lang=js&"
export * from "./EmissionsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EmissionsTemplate.vue?vue&type=style&index=0&id=87895912&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87895912",
  null
  
)

export default component.exports